import utils from '../../utils'

const BinaryWriter = function (capacity) {
    if (typeof capacity === 'undefined') {
        this.array = [];
    }
    else if (utils.isArray(capacity)) {
        this.array = capacity;
    }
    else {
        this.buffer = new ArrayBuffer(capacity);
        this.array = new Uint8Array(this.buffer);
        this.capacity = capacity;
    }
    this.position = 0;
};

const pt = BinaryWriter.prototype;

pt.writeInt8 = function(byte) {
    this.array[this.position++] = (byte & 0xFF);
};

pt.writeInt16 = function(value) {
    this.array[this.position++] = ((value >> 8) & 0xFF);
    this.array[this.position++] = ((value >> 0) & 0xFF);
};

pt.writeInt32 = function(value) {
    this.array[this.position++] = ((value >> 24) & 0xFF);
    this.array[this.position++] = ((value >> 16) & 0xFF);
    this.array[this.position++] = ((value >>  8) & 0xFF);
    this.array[this.position++] = ((value >>  0) & 0xFF);
};

pt.writeInt64 = function(value) {
    this.array[this.position++] = ((value >> 56) & 0xFF);
    this.array[this.position++] = ((value >> 48) & 0xFF);
    this.array[this.position++] = ((value >> 40) & 0xFF);
    this.array[this.position++] = ((value >> 32) & 0xFF);
    this.array[this.position++] = ((value >> 24) & 0xFF);
    this.array[this.position++] = ((value >> 16) & 0xFF);
    this.array[this.position++] = ((value >>  8) & 0xFF);
    this.array[this.position++] = ((value >>  0) & 0xFF);
};

pt.writeString = function(s) {
    if (s) {
        var bytes = utils.stringToUtf8ByteArray(s);
        this.writeInt32(bytes.length);
        this.writeByteArray(bytes, 0, bytes.length);
    }
    else {
        this.writeInt32(0);
    }
};

pt.writeArrayBuffer = function(buf, offset, count) {
    if (typeof offset === 'undefined') offset = 0;
    if (typeof count === 'undefined') count = buf.byteLength - offset;
    const array = new Uint8Array(buf);
    for (let i = offset, end = offset + count; i < end; i++) {
        this.array[this.position++] = (array[i] & 0xFF);
    }
};

pt.writeByteArray = function(array, offset, count) {
    if (typeof offset === 'undefined') offset = 0;
    if (typeof count === 'undefined') count = array.length - offset;
    for (let i = offset, end = offset + count; i < end; i++) {
        this.array[this.position++] = (array[i] & 0xFF);
    }
};

pt.writeArrayBufferOrByteArray = function(data, offset, count) {
    if (data instanceof ArrayBuffer) {
        this.writeArrayBuffer(data, offset, count);
    }
    else {
        this.writeByteArray(data, offset, count);
    }
};

// 获取字符串占用的字节数
BinaryWriter.getStringSize = function (s) {
    if (s) {
        var bytes = utils.stringToUtf8ByteArray(s);
        return 4 + bytes.length;
    }
    else {
        return 4;
    }
};

export default BinaryWriter;
